import React from "react";
import "../styles/AboutUsBanner.css";
import myvideo from '../assets/whoweare.mp4'

const AboutUsBanner = () => {
  return (
    <section className="about-us-banner">
      <video
        className="aboutus-banner-video"
        src={myvideo}
        autoPlay
        loop
        muted
      ></video>
      <div className="aboutus-overlay">
        <div className="aboutus-content">
          <h1>Pioneering the Future of Robotics & Automation</h1>
          <p>Empowering industries with cutting-edge robotic solutions for a smarter tomorrow.</p>
        </div>
      </div>
    </section>
  );
};

export default AboutUsBanner;
